import useGetColors from './useGetColors'

export default useGetColors
